// @ts-check

/**@type {ThemeHideSections}*/
const hide = {}

export default hide
